
export default function MRReportTypesController(
) {
  const vm = this;

  vm.orderBy = 'reportName';

  vm.handleSort = handleSort;

  _activate();

  function handleSort(propertyName) {
    if (vm.orderBy === propertyName) {
      if (propertyName.startsWith('-')) {
        propertyName = propertyName.substring(1);
      } else {
        propertyName = `-${propertyName}`;
      }
    }
    vm.orderBy = propertyName;
  }

  /** ********************************************
   * Private Functions
   */

  function _activate() {
  }
}

MRReportTypesController.$inject = [
];
